import React, { useRef } from 'react'
import {
  CloseButton,
  StyledBody,
  StyledCard,
  StyledHeader,
  StyledHorinzontalSlash,
  StyledMedia,
  StyledModal,
  StyledSubtitle,
  StyledText,
  StyledTitle,
} from './CardModal.styled'
import PropTypes from 'prop-types'
import NormalizeMedia from '../../utils/NormalizeMedia'
import CKEditorContent from '../CKEditorContent/CKEditorContent'
import useOutsideClick from '../../hooks/useOutsideClick'

const CardModal = (props) => {
  const { className, onClose, isMobile, card } = props
  const wrapperRef = useRef(null)
  useOutsideClick(wrapperRef, onClose)
  return (
    <StyledModal className={className}>
      <StyledCard ref={wrapperRef}>
        <CloseButton onClick={onClose} />
        <StyledMedia>{NormalizeMedia(card.image)}</StyledMedia>
        <StyledBody>
          {card.titleLevel1 && (
            <StyledHeader>
              <StyledTitle>{card.titleLevel1}</StyledTitle>
            </StyledHeader>
          )}
          {card.titleLevel2 && (
            <StyledSubtitle>
              <StyledHorinzontalSlash />
              {card.titleLevel2}
            </StyledSubtitle>
          )}
          {card.descriptionHtml && (
            <StyledText>
              <CKEditorContent html={card.descriptionHtml?.content} />
            </StyledText>
          )}
        </StyledBody>
      </StyledCard>
    </StyledModal>
  )
}

CardModal.propTypes = {
  className: PropTypes.string,
  card: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
  isMobile: PropTypes.bool,
}

export default CardModal
